import React from 'react';
import PropTypes from 'prop-types';
import { InputBase } from '@material-ui/core';

const MyInputBase = ({ classes, ...props }) => <InputBase classes={{ root: classes.input }} {...props} />;

MyInputBase.propTypes = {
  classes: PropTypes.shape({}),
};

MyInputBase.defaultProps = {
  classes: {},
};

export default MyInputBase;
